module.exports = __webpack_public_path__ + "img/12-full-lg.55ec309a.jpg";